<template>
    <v-container>
      <loader v-if="loading"></loader>
      <data-table
        ref="table"
        :fetch-from="fetchForm"
        :fields="fields"
        @loaded="onTableLoaded"
      >
        <template
          slot="actions"
          slot-scope="slotData"
        >
          <v-btn
            x-small
            color="primary"
            @click="showDetails(slotData.rowData)"
          >Details</v-btn>
        </template>
      </data-table>
      <modal-form
        :title="title"
        :show.sync="dialog"
        :readonly="true"
        v-if="selectedSector"
      >
        <v-row>
          <v-col cols="3">
            <display-field label="Sector ID">{{ sectorDetails.SectorName }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="SectorNo">{{ selectedSector.sectorno }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="SiteId_NWP">{{ sectorDetails.siteid }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Candidate">{{ sectorDetails.Candidate}}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Easting GK5">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Northing GK5">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Easting HTRS96">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Northing HTRS96">Data not available</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field
              label="Latitude WGS84"
              :site="site"
              :editable="true"
              edit-field="sector.Latitude"
              :edit-value="sectorDetails.Latitude"
              :aid="sectorDetails.SectorName"
              @updated="(nv)=>sectorDetails.Latitude=nv"
              :update-params="{'Longitude': sectorDetails.Longitude}"
            >{{ sectorDetails.Latitude|formatCoordinates }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Longitude WGS84"
              :site="site"
              :editable="true"
              edit-field="sector.Longitude"
              :edit-value="sectorDetails.Longitude"
              :aid="sectorDetails.SectorName"
              @updated="(nv)=>sectorDetails.Longitude=nv"
              :update-params="{'Latitude': sectorDetails.Latitude}"
            >{{ sectorDetails.Longitude|formatCoordinates }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="AntennaDirection"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaDirection"
              :edit-value="sectorDetails.Direction"
              :aid="sectorDetails.SectorName"
              @updated="(nv)=>sectorDetails.AntennaDirection=nv"
            >{{ sectorDetails.Direction }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="AntennaElTilt"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElTilt"
              :aid="sectorDetails.SectorName"
            >{{ sectorDetails.ElTilt }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field
              label="AntennaHeight"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaHeight"
              :edit-value="sectorDetails.Height"
              :aid="sectorDetails.SectorName"
              @updated="(nv)=>sectorDetails.Height=nv"
            >{{ sectorDetails.Height }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="AntennaMechTilt"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaMechTilt"
              :edit-value="sectorDetails.MechTilt"
              :aid="sectorDetails.SectorName"
              @updated="(nv)=>sectorDetails.MechTilt=nv"
            >{{ sectorDetails.MechTilt }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="AntennaName"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaName"
              :edit-value="sectorDetails.AntennaModelName"
              :aid="sectorDetails.SectorName"
              edit-type="codelist"
              codelist="antenna"
              @updated="(nv)=>sectorDetails.AntennaModelName=nv"
            >{{ sectorDetails.AntennaModelName }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="FrequencyBand">{{ sectorDetails.Band }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="ElTiltType">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="RRU type">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 700"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt700"
              :aid="sectorDetails.ElectTilt700Sector"
              @updated="(nv)=>sectorDetails.ElectTilt700=nv"
            >{{ sectorDetails.ElectTilt700|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 900"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt900"
              :aid="sectorDetails.ElectTilt900Sector"
              @updated="(nv)=>sectorDetails.ElectTilt900=nv"
            >{{ sectorDetails.ElectTilt900|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 1800"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt1800"
              :aid="sectorDetails.ElectTilt1800Sector"
              @updated="(nv)=>sectorDetails.ElectTilt1800=nv"
            >{{ sectorDetails.ElectTilt1800|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 2100"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt2100"
              :aid="sectorDetails.ElectTilt2100Sector"
              @updated="(nv)=>sectorDetails.ElectTilt2100=nv"
            >{{ sectorDetails.ElectTilt2100|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 2600"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt2600"
              :aid="sectorDetails.ElectTilt2600Sector"
              @updated="(nv)=>sectorDetails.ElectTilt2600=nv"
            >{{ sectorDetails.ElectTilt2600|noDataAvailable }}</display-field>
          </v-col>
          <v-col cols="3">
            <display-field
              label="Elect. Tilt 3500"
              :site="site"
              :editable="true"
              edit-field="sector.AntennaElTilt"
              :edit-value="sectorDetails.ElectTilt3500"
              :aid="sectorDetails.ElectTilt3500Sector"
              @updated="(nv)=>sectorDetails.ElectTilt3500=nv"
            >{{ sectorDetails.ElectTilt3500|noDataAvailable }}</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="Cable Length">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Cable Loss">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Cable Type">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Diversity/MIMO">Data not available</display-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3">
            <display-field label="No of Antennas">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="RRU to Antenna Jumper Length">Data not available</display-field>
          </v-col>
          <v-col cols="3">
            <display-field label="Shared Antenna System">Data not available</display-field>
          </v-col>
        </v-row>
        <h3>Cells</h3>
        <cell-info
          :site="site"
          :sector="selectedSector"
        ></cell-info>
      </modal-form>
    </v-container>
</template>

<script>
  import DisplayField from '@/components/DisplayField'
  import CellInfo from '@/views/sites/sections/radio-frequency/CellInfo'
  import ModalForm from '@/components/ModalForm'
  import DataTable from '@/components/DataTable'
  import SiteNwpService from '@/services/site-nwp'
  import Loader from '@/components/Loader'
  export default {
    name: 'SectorInfo',
    components: { Loader, DataTable, ModalForm, CellInfo, DisplayField },
    props: {
      site: {
        default: undefined,
      },
      autoOpen: {
        default: false,
      },
    },
    data: function () {
      return {
        dialog: false,
        loading: false,
        sectorDetails: undefined,
        selectedSector: undefined,
        fields: [
          {
            name: 'sectorno',
            title: 'Sector number',
          },
          {
            name: 'sectorname',
            title: 'Sector name',
          },
          {
            name: '__slot:actions',
            title: 'Actions',
          },
        ],
        wasAutoLoaded: false,
      }
    },
    computed: {
      title () {
        if (this.selectedSector) {
          return 'Sector ' + this.selectedSector.sectorname
        }
        return 'Sector'
      },
    },
    methods: {
      fetchData () {

      },
      fetchForm (urls, options) {
        const acs = new SiteNwpService()
        return acs.sectors(this.site.id)
      },
      showDetails (item) {
        this.loading = true
        this.selectedSector = item
        const acs = new SiteNwpService()
        return acs.sectorDetails(this.site.id, this.selectedSector.sector_id).then((response) => {
          this.sectorDetails = response.data.data
          this.dialog = true
        }).finally(() => {
          this.loading = false
        })
      },
      onTableLoaded () {
        if (this.autoOpen != null && !this.wasAutoLoaded) {
          const data = this.$refs.table.getData()
          for (const item of data) {
            if (item.sectorname + '' === this.autoOpen) {
              setTimeout(() => {
                this.wasAutoLoaded = true
                this.showDetails(item)
              }, 200)
              break
            }
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
